export default "__VITE_ASSET__Dox9R7g1__"